import { useTranslation } from 'react-i18next';
import React from 'react';
import { CustomButton } from '../../../UiComponentsLibrary/CustomButton';
import { userManagementCardActions } from '../../config/actionButtonsConfig';
import { USER_STATUS } from '../../constants/userStatus';
import { ACTION_TYPES } from '../../constants/actionsTypes';
import { handleUserManagementCardActions } from './userManagementCardActionsHelpers';
import { canUserEdit } from '../../../Shared/utils/helpers';
import { useAppContext } from '../../../Shared/store/appContext';

export interface UserManagementCardActionProps {
  setIsCreateUser?: (value: boolean) => void;
  handleStatusUsersView?: (
    value: (typeof USER_STATUS)[keyof typeof USER_STATUS]
  ) => void;
}

const UserManagementCardActions = (props: UserManagementCardActionProps) => {
  const { setIsCreateUser, handleStatusUsersView } = props;
  const { t } = useTranslation();
  const { state } = useAppContext();
  const canEdit = canUserEdit(state.currentUser?.permissions);

  return (
    <>
      {Object.entries(userManagementCardActions).map(([action, value]) => (
        <div id={`user-management-card-action-button-${action}`} key={action}>
          <CustomButton
            text={t(value.text)}
            backgroundColor={value.backgroundColor}
            disabled={action === ACTION_TYPES.CREATE_USER && !canEdit}
            tooltip={action === ACTION_TYPES.CREATE_USER && !canEdit ? t('no-edit-permission-tooltip') : undefined}
            handleOnClickCb={() =>
              handleUserManagementCardActions(
                action,
                setIsCreateUser,
                handleStatusUsersView
              )
            }
          />
        </div>
      ))}
    </>
  );
};

export default UserManagementCardActions;
